/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Type of the value
 */
export const AlarmSnapshotKind = {
  Number: "number",
  Boolean: "boolean",
  Enum: "enum",
} as const;
/**
 * Type of the value
 */
export type AlarmSnapshotKind = OpenEnum<typeof AlarmSnapshotKind>;

/**
 * Snapshot of a control point or setting at shared.Time of alarm activation
 */
export type AlarmSnapshot = {
  /**
   * Boolean value of the reading
   */
  boolean?: boolean | undefined;
  /**
   * Enum value of the reading
   */
  enum?: string | undefined;
  /**
   * Universally unique identifier
   */
  id: string;
  /**
   * Type of the value
   */
  kind?: AlarmSnapshotKind | undefined;
  /**
   * Number value of the reading
   */
  number?: number | undefined;
  /**
   * Units of the linked control point or setting at shared.Time of activation
   */
  unit?: string | undefined;
};

/** @internal */
export const AlarmSnapshotKind$inboundSchema: z.ZodType<
  AlarmSnapshotKind,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AlarmSnapshotKind);

/** @internal */
export const AlarmSnapshot$inboundSchema: z.ZodType<
  AlarmSnapshot,
  z.ZodTypeDef,
  unknown
> = z.object({
  boolean: types.optional(types.boolean()),
  enum: types.optional(types.string()),
  id: types.string(),
  kind: types.optional(AlarmSnapshotKind$inboundSchema),
  number: types.optional(types.number()),
  unit: types.optional(types.string()),
});

export function alarmSnapshotFromJSON(
  jsonString: string,
): SafeParseResult<AlarmSnapshot, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AlarmSnapshot$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AlarmSnapshot' from JSON`,
  );
}
